import React, { useEffect, useState } from 'react'; 
import '../style/Car.css';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegStar, FaPhoneAlt, FaRegImage, FaRegCommentDots } from 'react-icons/fa';
import { Modal, Button, Carousel } from 'react-bootstrap';
import sedanImage from '../img/car1.jpg'; 
import suvImage from '../img/car2.jpg';
import minivanImage from '../img/car3.jpg';
import fourByFourImage from '../img/car4.jpg';
import { carRentalData,carCategories } from './dummydata';
import vanaTourLogo from '../img/PikPng.com_carros-png_2200174.png'; 
import avatar1 from '../img/41 Sleek Bun Hairstyles for Black Women_ A Style Guide - yourwifeknows_com.jpg'; // Replace with the actual image path
import avatar2 from '../img/Jasper Lovell.jpg'; // Replace with the actual image path
import avatar3 from '../img/download (19).jpg'; // Replace with the actual image path
import { useDispatch } from 'react-redux';
import { setSelectedCar } from '../Store/userSlice';
import { useNavigate } from 'react-router-dom';
import { getCars, getCatagory } from '../Functions/apifunctions';
const CarRental = () => {
  const dispatch= useDispatch();
  const navigate= useNavigate();
  const [showContact, setShowContact] = useState({}); // Track modal visibility for each car
  const [showGallery, setShowGallery] = useState({}); // Track gallery modal visibility for each car
  const [currentCar, setCurrentCar] = useState(null); // Track the current car for the gallery
  const [filterdCars,setfilterdCars]=useState(null);
  const [catagories,setCatagories]=useState(null);
  const [filterForm,setFilterForm]=useState({
    type:"",
    transmition:"",
    pickupdate:""
  })
  const toggleContact = (carIndex) => {
    setShowContact(prev => ({ ...prev, [carIndex]: !prev[carIndex] }));
  };
  // handel form change
  const onhandelChange=(e)=>{
    setFilterForm((prev)=>({
      ...prev,[e.target.name]:e.target.value
    }))
    setfilterdCars(carRentalData.filter((car)=>car.categoryName==e.target.value));
  }

  const toggleGallery = (carIndex, car) => {
    setCurrentCar(car); // Set the current car for gallery
    setShowGallery(prev => ({ ...prev, [carIndex]: !prev[carIndex] }));
  };
//select a car to book
const BookCar=(car)=>{
  dispatch(setSelectedCar(car));
  navigate("/booking");
  
 
}
const fetch_data= ()=>{
  getCatagory().then((res)=>{
 
    setCatagories(res.categories);
    
  })
  getCars().then((res)=>{
   
    setfilterdCars(res.cars)
  
  })
}
 
useEffect(()=>{
  fetch_data();
},[])

 
  return (
    <div>
      <section className="car-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="car-heading">Car Rentals</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Row to display car rental cards */}
      <div className="container-fluid  mt-5 px-2 px-md-5">
        <div className='row bg-warning rounded  py-5 p '>
          <div className='col-sm-12 col-lg-6'>
          <div className="d-flex flex-column  p-2">
          <label for="car name " className=" text-start form-label  fw-bold">Car Type</label>

          <select className="form-select form-select-lg h-100  " onChange={onhandelChange} name='type' value={filterForm.type}>
          <option key="" value=""  disabled></option>
          {catagories && catagories.map((category,index) => (
      <option key={index} value={category._id}>
      {category.name}
    </option>
            ))}
          </select>
          </div>
          </div>
          <div className='col-sm-12 col-lg-2'>
              <div className='d-flex flex-column p-2'>
              <label for="car name " className=" text-start form-label  fw-bold">Transmition</label>
              <select className="form-select form-select-lg h-100 " onChange={onhandelChange} value={filterForm.transmition} name='transmition'>
              <option value=""></option>
              <option value="Manual"> Manual</option>
              <option value="Manual"> Automatic</option>
              </select>
              </div>
          </div>
          <div className='col-sm-12 col-lg-2'>
          <div className='d-flex flex-column p-2'>
          <label for="car name " className=" text-start form-label  fw-bold">Pickup Date</label>
             <input type='date' name="pickupdate" onChange={onhandelChange} value={filterForm.pickupdate}  className='form-control form-control-lg '/>
          </div>
          </div>
          <div className='col-sm-12 col-lg-2 d-flex mt-2  p-2 align-items-center '>
            <div className=' w-100 pt-md-4'>
              <button className='btn w-100 btn-primary fw-bold my-auto'> Search</button>
            </div>

          </div>

        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          {
           filterdCars && filterdCars.map((car,index)=>(
              
               
                  <div key={index} className="col-md-4 col-sm-6 col-xs-12 mb-4">
                    <Card className="car-card">
                      <Card.Img variant="top" src={`http://localhost:8000${car.mainImage}`} className="car-images" />
                      <Card.Body>
                      <div className="d-flex justify-content-end align-items-end py-1">
                          <span className="text-end text-secondary small">{car.categoryId.name}</span>
                        </div>
                      
                        <Card.Title className="car-title">{car.name}</Card.Title>
                        <Card.Text className="car-description">
                          {car.description}
                        </Card.Text>
                      </Card.Body>
                      <ListGroup className="list-group-flush">
                        <ListGroup.Item className="list-item">
                          <div className="d-flex justify-content-between">
                            <div><FaRegStar className="icon" /> Details</div>
                            <div><FaRegCommentDots className="icon" /> Message</div>
                            <div>
                              <FaRegImage 
                                className="icon" 
                                onClick={() => toggleGallery(index, car)} 
                                style={{ cursor: 'pointer' }} 
                              />
                              Zoom
                            </div>
                          </div>
                        </ListGroup.Item>
                      </ListGroup>
                      <Card.Body>
                        <div className="d-flex justify-content-between">
                          <div><FaRegStar className="icon" /> Car</div>
                          <div>
                            <FaPhoneAlt 
                              className="icon" 
                              onClick={() => toggleContact(index)} 
                              style={{ cursor: 'pointer' }} 
                            />
                            Contact
                          </div>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center py-3 mt-3">
                          <span className="book-now w-100" onClick={()=>BookCar(car)}>Book Now</span>
                        </div>
                      </Card.Body>
      
                      {/* Contact Modal */}
                      <Modal show={showContact[index]} onHide={() => toggleContact(index)}>
                        <Modal.Header closeButton>
                          <Modal.Title>Contact</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p>Name: {car.contactName}</p>
                          <p>Phone: {car.contactPhone}</p>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={() => toggleContact(index)}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
      
                      {/* Gallery Modal with Carousel */}
                      <Modal show={showGallery[index]} onHide={() => toggleGallery(index, car)} size="lg">
                        <Modal.Header closeButton>
                          <Modal.Title>Gallery</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Carousel>
                            {currentCar && currentCar.gallery.map((image, idx) => (
                              <Carousel.Item key={idx}>
                                <img loading='lazy' src={`http://localhost:8000${image}`} alt={ currentCar.categoryId.name} className="d-block w-100" />
                              </Carousel.Item>
                            ))}
                          </Carousel>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={() => toggleGallery(index, car)}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </Card>
                  </div>
              
           ))
          }

        </div>
      </div>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="pe-lg-3">
                <h1 className="display-3 fw-bold mb-2 mb-md-3">Book Your Dream Car with <span className="text-primary">Vana Rentals</span></h1>
                <p className="lead mb-4">Explore the best car rental options for your next adventure. Choose from a variety of vehicles and enjoy a smooth driving experience.</p>
              </div>
              <div className="row">
                <div className="col-sm-6 mb-3 mb-sm-0">
                  <div className="d-flex">
                    <div class="flex-shrink-0">
                      <div className="text-primary">
                        <svg class="bi bi-chat-right-fill" fill="currentColor" height="32" viewbox="0 0 16 16" width="32" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 0a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"></path>
                        </svg>
                      </div>
                    </div>
                    <div className="ms-3">
                      <h6 className="mb-0">24/7</h6>
                      <p>Customer Support</p>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="d-flex">
                    <div className="text-primary">
                      <svg className="bi bi-shield-fill-check" fill="currentColor" height="32" viewbox="0 0 16 16" width="32" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.828-.24c.305-.143.662-.352 1.048-.625a11.777 11.777 0 0 0 2.465-9.99A1.54 1.54 0 0 0 12.815 2.43c-.658-.215-1.777-.571-2.887-.87C9.843.265 8.69 0 8 0z"></path>
                      </svg>
                    </div>
                    <div className="ms-3">
                      <h6 className="mb-0">Insurance Included</h6>
                      <p>Comprehensive Coverage</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 ms-lg-5">
              <div className="bg-white rounded-3 p-4 shadow-sm">
                <h4 className="mb-4">Book Your Car</h4>
                <form>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input type="text" className="form-control" id="name" required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="email" required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone number</label>
                    <input type="tel" className="form-control" id="phone" required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="car-type" className="form-label">Car Type</label>
                    <select className="form-select" id="car-type" required>
                      <option value="">Choose a car</option>
                      {carCategories.map((car, index) => (
                        <option key={index} value={car.name}>{car.categoryName}</option>
                      ))}
                    </select>
                  </div>
                  <button type="submit" className="btn btn-primary w-100">Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="bottom-image-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', overflow: 'hidden' }}>
  <img 
    src={vanaTourLogo} 
    alt="Vana Tour and Car Rental" 
    className="bottom-image" 
    style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} 
  />
</div>

<div className="bg-light">
  <div className="container py-5">
    <h2 className="text-center mb-5 text-primary">What Our Customers Say About Vana Tour & Car Rental</h2>
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <div className="row">
          {/* First Testimonial */}
          <div className="col-md-4 mb-4">
            <div className="testimonial-card p-4 p-md-5">
              <i className="bi bi-quote quote-icon position-absolute top-0 start-0 mt-3 ms-3"></i>
              <div className="text-center mb-4">
                <img src={avatar1} alt="Avatar" className="avatar mb-3" />
                <h5 className="mb-1">Tadesse Gebremedhin</h5>
                <p className="text-muted mb-0">Tourist</p>
              </div>
              <p className="lead text-center mb-0">
                "Vana’s car rental service made our trip through Ethiopia so smooth and enjoyable. The vehicles were in great condition, and the team was incredibly helpful. Highly recommend for anyone visiting!"
              </p>
            </div>
          </div>

          {/* Second Testimonial */}
          <div className="col-md-4 mb-4">
            <div className="testimonial-card p-4 p-md-5">
              <i className="bi bi-quote quote-icon position-absolute top-0 start-0 mt-3 ms-3"></i>
              <div className="text-center mb-4">
                <img src={avatar2} alt="Avatar" className="avatar mb-3" />
                <h5 className="mb-1">Mariam Abebe</h5>
                <p className="text-muted mb-0">Business Owner</p>
              </div>
              <p className="lead text-center mb-0">
                "The tours offered by Vana were incredible! We explored some of the most beautiful landscapes in Ethiopia, and the guide was knowledgeable and friendly. It truly exceeded our expectations."
              </p>
            </div>
          </div>

          {/* Third Testimonial */}
          <div className="col-md-4 mb-4">
            <div className="testimonial-card p-4 p-md-5">
              <i className="bi bi-quote quote-icon position-absolute top-0 start-0 mt-3 ms-3"></i>
              <div className="text-center mb-4">
                <img src={avatar3} alt="Avatar" className="avatar mb-3" />
                <h5 className="mb-1">Hassan Mohammed</h5>
                <p className="text-muted mb-0">Corporate Client</p>
              </div>
              <p className="lead text-center mb-0">
                "Vana’s service was exceptional! The car rental process was seamless, and the tour guides really made our experience unforgettable. I'll be using them again for my next business trip to Ethiopia."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="py-5">
	<div class="container">
		<div class="row justify-content-center text-center mb-2 mb-lg-4">
			<div class="col-12 col-lg-8 col-xxl-7 text-center mx-auto">
				<span class="text-muted">Our Team</span>
				<h2 class="display-5 fw-bold">Meet the Team</h2>
				<p class="lead">At Vana Tour and Car Rental, we are dedicated to providing you with the best travel and car rental experience across Ethiopia. Our team is here to ensure you have a smooth and enjoyable journey.</p>
			</div>
		</div>
		<div class="row">
	
			<div class="col-lg-6">
				<div class="card border-0 mb-3">
					<div class="row g-0 align-items-center bg-light">
						<div class="col-sm-5">
            <img alt="Avatar 3" className="img-fluid" src={avatar3} /> 
						</div>
						<div class="col-sm-7">
							<div class="card-body mx-md-3">
								<h5 class="fw-bold text-primary">Addis Alemu</h5>
								<div class="text-muted mb-4">
									Car Rental Manager
								</div>
								<p>With years of experience in the car rental industry, Addis is here to provide you with the best vehicle options for your journey in Ethiopia.</p>
								<div class="d-flex mt-4">
									<a class="btn btn-sm me-2" href=""><svg class="bi bi-facebook" fill="currentColor" height="16" viewbox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
										<path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"></path>
									</svg></a>
									<a class="btn btn-sm me-2" href=""><svg class="bi bi-twitter" fill="currentColor" height="16" viewbox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
										<path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0="></path>
									</svg></a>
						
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			
			<div class="col-lg-6">
				<div class="card border-0 mb-3">
					<div class="row g-0 align-items-center bg-light">
						<div class="col-sm-5">
            <img alt="Avatar 2" className="img-fluid" src={avatar2} />
						</div>
						<div class="col-sm-7">
							<div class="card-body mx-lg-3">
								<h5 class="fw-bold text-primary">Mulugetta Tesfaye</h5>
								<div class="text-muted mb-4">
									Tour Guide Specialist
								</div>
								<p>Mulugetta brings deep knowledge of Ethiopian history and culture, ensuring an unforgettable tour experience across Ethiopia's most beautiful destinations.</p>
								<div class="d-flex mt-4">
									<a class="btn btn-sm me-2" href=""><svg class="bi bi-facebook" fill="currentColor" height="16" viewbox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
										<path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"></path>
									</svg></a>
									<a class="btn btn-sm me-2" href=""><svg class="bi bi-twitter" fill="currentColor" height="16" viewbox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
										<path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0="></path>
									</svg></a>
								
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>  
		</div>
	</div>
</section>
  </div>
</div>


</div>

  );
};

export default CarRental;
